// extracted by mini-css-extract-plugin
export default {"icon":"AdminFavMenu_icon__l9rWF","favCont":"AdminFavMenu_favCont__KJ6KC"};